import { adminDashboard } from './dashboard';
import { adminUsers } from './users';
import { adminCommunity } from './community';
import { adminAccounts } from './accounts';
import { adminCommissions } from './commissions';

export const adminEs = {
  ...adminDashboard,
  ...adminUsers,
  ...adminCommunity,
  ...adminAccounts,
  ...adminCommissions,
};